$( document ).ready(function() {

	$('.slidesOut').delay(3000).slideUp(300);

});